module.exports = __webpack_public_path__ + "img/field-dark-6.2cb08238.svg";